import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
import state from './state'

const module = {
  actions,
  mutations,
  getters,
  state
}

export default { module }
